import { List, Typography } from 'antd';
import { customizeRenderEmpty } from 'components/common';
import React, { useMemo } from 'react';
import VirtualList from 'rc-virtual-list';
import OmniChannelChatHistoriesSessionItem from './OmniChannelChatHistoriesSessionItem';
import dayjs from 'dayjs';
import { twMerge } from 'tailwind-merge';
import { InView } from 'react-intersection-observer';
import OmniChannelChatHistoriesSessionItemSkeleton from './OmniChannelChatHistoriesSessionItemSkeleton';
import { formatNumber } from 'utils';
import { useOmniHistoriesManageContext } from 'contexts';
import { ChatHistoryGroup, ChatSessionDto } from 'types';

type Props = {};

const renderSkeletonItems = () => {
  return Array.from({ length: 5 }).map((_, index) => (
    <div key={`skeleton-${index}`} className='w-full border-b'>
      <OmniChannelChatHistoriesSessionItemSkeleton />
    </div>
  ));
};

const renderChatHistoryGroup = (
  group: ChatHistoryGroup,
  groupIndex: number,
  onClick: (item: ChatSessionDto) => void
) => {
  return (
    <div key={group.date} className={twMerge(groupIndex !== 0 ? 'mt-4' : '')}>
      <div className='px-6 pb-3 pt-2'>
        <Typography.Text type='secondary' className='text-sm font-semibold'>
          {dayjs(group.date).format('DD/MM/YYYY')}
        </Typography.Text>
      </div>
      <div className='flex flex-col'>
        {group.sessions.map((session) => (
          <div className='h-auto w-full border-b p-0' key={session.chatSessionId}>
            <OmniChannelChatHistoriesSessionItem onClick={() => onClick(session)} item={session} />
          </div>
        ))}
      </div>
    </div>
  );
};

const OmniChannelChatHistoriesSectionList: React.FC<Props> = ({}) => {
  const {
    groupedData,
    hasMoreChatSessions,
    countChatSessions,
    setChatSession: setChatSessions,
    loadMoreChatSessions
  } = useOmniHistoriesManageContext();

  const handleInViewChange = (isVisible: boolean) => {
    if (isVisible) {
      loadMoreChatSessions();
    }
  };

  const handleSelectChatSession = (session: ChatSessionDto) => {
    setChatSessions(session);
  };

  if (!groupedData || groupedData.length === 0) {
    return (
      <div className='flex h-full w-full flex-col'>
        <div className='flex items-center justify-center pt-[88px]'>{customizeRenderEmpty()}</div>
      </div>
    );
  }
  return (
    <div className='flex h-full w-full flex-col'>
      <div className='flex h-11 items-center px-6'>
        <Typography.Text className='italic' type='secondary'>
          {formatNumber(countChatSessions ?? 0)} Kết quả
        </Typography.Text>
      </div>
      <List className='max-h-full w-full flex-1 overflow-auto pb-6'>
        <VirtualList itemKey='title' data={groupedData} fullHeight>
          {(group: ChatHistoryGroup, groupIndex: number) =>
            renderChatHistoryGroup(group, groupIndex, handleSelectChatSession)
          }
        </VirtualList>
        {hasMoreChatSessions && <InView onChange={handleInViewChange}>{renderSkeletonItems()}</InView>}
      </List>
    </div>
  );
};
export default OmniChannelChatHistoriesSectionList;
